import * as React from 'react';

export const Calendar: React.FC = () => {
  return <h1>Calendar page</h1>;
};
